import { useState } from "react";

import { Row, Badge } from "react-bootstrap";

import { skills } from "../Data";

const Skills = () => {
    const [copied, setCopied] = useState("");

    const copyHandler = ({ label, tech }) => {
        setCopied(label);
        var s = tech.join(" , ");

        navigator.clipboard.writeText(s);
        setTimeout(() => setCopied(""), 750);
    };

    const copyAllHandler = () => {
        setCopied("All");
        var all = skills.flatMap(skill => skill.tech).join(" , ");

        navigator.clipboard.writeText(all);
        setTimeout(() => setCopied(""), 750);
    }

    return (
        <>
            <div className="d-flex justify-content-end">
                <small>
                    <b><i>
                        {copied === "All" ? (
                            "Copied"
                        ) : (
                            <u
                                onClick={copyAllHandler}
                                style={{ cursor: "pointer" }}
                            >
                                <i>Copy All</i>
                            </u>
                        )}
                    </i></b>
                </small>
            </div>
            {skills.map((skill) => (
                <Row key={skill.label} className="mb-4">
                    <h6>
                        <b>{skill.label}</b>
                        &nbsp;&nbsp;
                        <small>
                            {copied === skill.label ? (
                                "Copied"
                            ) : (
                                <u
                                    onClick={() =>
                                        copyHandler({
                                            label: skill.label,
                                            tech: skill.tech,
                                        })
                                    }
                                    style={{ cursor: "pointer" }}
                                >
                                    <i>Copy</i>
                                </u>
                            )}
                        </small>
                    </h6>
                    <div>
                        {skill.tech.map((name) => (
                            <Badge
                                key={name}
                                className="me-3 mb-2"
                                style={{ fontSize: "13px" }}
                            >
                                {name}
                            </Badge>
                        ))}
                    </div>
                </Row>
            ))}
        </>
    );
};

export default Skills;
